import { NotificationsAction } from '../../actions/notifications/NotificationsAction'
import NotificationsActionTypes from '../../actions/notifications/NotificationsActionTypes'
import {INotificationsState} from './INotificationsState'

export const initialState: INotificationsState = {
  notifications: [],
}

export const NotificationsReducer = function Notifications(state: INotificationsState = {...initialState}, action: NotificationsAction): INotificationsState {
  switch (action.type) {
    case NotificationsActionTypes.SET_NOTIFICATION:
      // Guard against duplicate ids reaching the store (second line behind PushDedup).
      if (state.notifications.some(notification => notification.id === action.payload.notification.id)) {
        return state
      }
      return {
        ...state,
        notifications: [
          ...state.notifications,
          action.payload.notification,
        ],
      }
    case NotificationsActionTypes.CLOSE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload.id),
      }
    default:
      return state
  }
}

